import { LoopWinsComponent } from "ags/components/loop-wins-component";
import { FreespinScatterResult } from "ags/integration/model/results/freespin-scatter-result";
import { SparkResult } from "ags/integration/model/results/spark-result";
import { Components } from "appworks/components/components";
import { Contract } from "appworks/utils/contracts/contract";
import { CelebrateWinComponent } from "slotworks/components/celebrate-win/celebrate-win-component";
import { FooterComponent } from "slotworks/components/footer/footer-component";
import { BonusResult } from "slotworks/model/gameplay/records/results/bonus-result";
import { LineResult } from "slotworks/model/gameplay/records/results/line-result";
import { ScatterResult } from "slotworks/model/gameplay/records/results/scatter-result";
import { slotDefinition } from "slotworks/model/slot-definition";

export class ThemeLoopWinsComponent extends LoopWinsComponent {
    constructor() {
        super();
    }

    protected override getCelebrationsForWin(win: any): Array<() => Contract<void>> {
        const celebrateWin: CelebrateWinComponent = Components.get(CelebrateWinComponent);

        if (win instanceof BonusResult) {
            return [
                () => celebrateWin.miscWin(win, "progressive_win_footer")
            ];
        }
        //for scatter win
        if (win instanceof ScatterResult) {
            return [
                () => this.showWin(win),
            ];
        }

        if (win instanceof SparkResult) {
            return [
                () => this.showWin(win),
                () => celebrateWin.miscWin(win, "progressive_win_footer")
            ];
        }

        const symbolDef = slotDefinition.getSymbolDefinition(win.symbolType);
        const symbolName = symbolDef ? symbolDef.name : "";

        if (win instanceof LineResult) {
            return [
                () => celebrateWin.lineWin(win, symbolName),
                () => this.showWin(win)
            ];
        }

        if (win instanceof FreespinScatterResult) {
            return [
                // TODO
                //  () => celebrateWin.scatterWin(win),
                () => this.showWin(win)
            ];
        }

        return [
            () => celebrateWin.waysWin(win, symbolName),
            () => this.showWin(win)
        ];
    }
}
